import React from 'react';
import { cn } from '../../lib/cn';

interface LedgerSkeletonProps {
  lines?: number;
  className?: string;
  'data-testid'?: string;
}

/** Loading state drawn as unfilled ledger lines, not gray blobs. */
export const LedgerSkeleton: React.FC<LedgerSkeletonProps> = ({ lines = 3, className, 'data-testid': testId }) => (
  <div role="status" aria-label="Loading" data-testid={testId} className={cn('animate-pulse space-y-3', className)}>
    {Array.from({ length: lines }, (_, i) => (
      <div key={i} className="h-3 border-b border-rule-faint"
        style={{ width: `${100 - (i % 3) * 12}%` }} />
    ))}
    <span className="sr-only">Loading…</span>
  </div>
);
